module.exports = __webpack_public_path__ + "img/Beowulf_Enes-som-flykter-fra-Troja.36c3d985.jpg";